import './styles.scss'

import React, { Component } from 'react'

export default class Index extends Component {
  render() {
    const { icon } = this.props
    return (
      <button className='sms-login-button' onClick={() => this.props.callback(null, 'sms')}>
        {icon && <i className={`fa ${icon}`} />}
        SMS
      </button>
    )
  }
}
